export enum Viewer {
    EML = 'EML',
    IMAGE = 'IMAGE',
    PDF = 'PDF',
    MEDIA = 'MEDIA',
    WARC = 'WARC',
    NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export const EXTENSION_VIEWER_MAPPING: Record<string, Viewer> = {
    eml: Viewer.EML,
    rfc822: Viewer.EML,
    jpeg: Viewer.IMAGE,
    jpg: Viewer.IMAGE,
    png: Viewer.IMAGE,
    pdf: Viewer.PDF,
    mp3: Viewer.MEDIA,
    mp4: Viewer.MEDIA,
    warc: Viewer.WARC,
    wacz: Viewer.WARC
};

// Viewers that use the original representation
export const VIEWERS_USING_ORIGINAL_REPRESENTATION: Viewer[] = [Viewer.WARC];
